import { Loader } from "@googlemaps/js-api-loader";

let loader: Loader | null = null;

export const useGoogleMapsLoader = () => {
  const config = useRuntimeConfig();

  if (!loader) {
    loader = new Loader({
      apiKey: config.public.apiGoogleMapKey as string,
      version: "weekly",
      libraries: ["places", "marker"],
    });
  }

  return loader;
};
